import React from 'react';
import { motion } from 'framer-motion';
import { Download, FileCheck, Infinity, Printer, Gift } from 'lucide-react';
export function AccessDetails() {
  const details = [{
    icon: <Download className="w-5 h-5" data-id="element-15" />,
    text: 'Acceso inmediato al material completo'
  }, {
    icon: <FileCheck className="w-5 h-5" data-id="element-16" />,
    text: 'Descarga digital en PDF y Word editable'
  }, {
    icon: <Infinity className="w-5 h-5" data-id="element-17" />,
    text: 'Acceso de por vida (actualizaciones incluidas)'
  }, {
    icon: <Printer className="w-5 h-5" data-id="element-18" />,
    text: 'Podés imprimir cuando lo necesites'
  }, {
    icon: <Gift className="w-5 h-5" data-id="element-19" />,
    text: 'Los 3 bonos incluidos desde el primer día'
  }];
  return <section className="py-16 bg-[#1a2332]" data-id="element-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-22">
          <h2 className="text-3xl font-bold text-white mb-10" data-id="element-23">
            ACCESO INMEDIATO
          </h2>

          <p className="text-gray-400 mb-8" data-id="element-24">Después de comprar recibís:</p>

          <div className="grid md:grid-cols-2 gap-4 max-w-2xl mx-auto text-left" data-id="element-25">
            {details.map((detail, index) => <div key={index} className="flex items-center gap-3 bg-[#111827] p-4 rounded-lg border border-gray-800" data-id="element-26">
                <div className="text-green-500 flex-shrink-0" data-id="element-27">
                  {detail.icon}
                </div>
                <span className="text-gray-200" data-id="element-28">{detail.text}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}